export default {"src":"/_next/static/media/arrow-rightV2.ccae96a2.svg","height":14,"width":9,"blurWidth":0,"blurHeight":0};